let lastScrollY = window.scrollY;
let lastDirection = null;

const scrollDirectionInit = () => {
  const body = document.querySelector('body');

  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;
    let direction = null;
    if (currentScrollY > lastScrollY) {
      direction = 'down';
    } else if (currentScrollY < lastScrollY) {
      direction = 'up';
    }

    if (currentScrollY === 0) {
      // Remove previous direction classes
      body.classList.remove('scrolling-up', 'scrolling-down');
    } else {
      if (direction && direction !== lastDirection) {
        // Remove previous direction classes
        body.classList.remove('scrolling-up', 'scrolling-down');
        // Add the new direction class
        body.classList.add(`scrolling-${direction}`);
        lastDirection = direction;
      }
    }

    lastScrollY = currentScrollY;
  });
};

export default scrollDirectionInit;
